import script from "./TimesheetReviewWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./TimesheetReviewWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./TimesheetReviewWorkspace.vue?vue&type=style&index=0&id=b5029bc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5029bc4"]])

export default __exports__